enum AdCampaigns {
    Add = 'ad-campaigns.add',
    Delete = 'ad-campaigns.delete',
    Edit = 'ad-campaigns.edit',
    View = 'ad-campaigns.view',
}

enum AdMetrics {
    View = 'ad-metrics.view',
}

enum AdPosts {
    Boost = 'ad-posts.boost',
    Promote = 'ad-posts.promote',
    View = 'ad-posts.view',
}

enum AdSettings {
    Edit = 'ad-settings.edit',
    View = 'ad-settings.view',
}

enum AdPrivilegedCampaigns {
    Import = 'ad-privileged-campaigns.import',
}

enum AgencyActions {
    ReviewAdmin = 'agency-reviews.assign-ticket',
    BLAdmin = 'agency-business-listings.assign-ticket',
    ReviewAgent = 'agency-reviews.operate-ticket',
    BLAgent = 'agency-business-listings.operate-ticket',
    Engineer = 'agency-actions-engineer.view',
    ViewModerationTicket = 'agency-reviews.view-moderation-ticket',
}

enum AnalyticAIO {
    View = 'analytic-aio.view',
}

enum AnalyticARMResponseMonitoring {
    Add = 'analytic-arm-response-monitoring.add',
    Delete = 'analytic-arm-response-monitoring.delete',
    View = 'analytic-arm-response-monitoring.view',
}

enum AnalyticARMResponseMonitoringUsers {
    Add = 'analytic-arm-response-monitoring-users.add',
    Delete = 'analytic-arm-response-monitoring-users.delete',
    View = 'analytic-arm-response-monitoring-users.view',
}

enum AnalyticARMResponseInsights {
    View = 'analytic-arm-response-insights.view',
}

enum AnalyticARMPresenceDashboard {
    Add = 'analytic-arm-presence-dashboard.add',
    View = 'analytic-arm-presence-dashboard.view',
}

enum AnalyticJourneyInsights {
    View = 'analytic-customer-journey-insight.view',
    Edit = 'analytic-customer-journey-insight.edit',
}

enum AnalyticInsights {
    View = 'analytic-insights.view',
}

enum AnalyticInsightsSettings {
    View = 'analytic-insights-settings.view',
}

enum AnalyticReports {
    Add = 'analytic-reports.add',
    Delete = 'analytic-reports.delete',
    Edit = 'analytic-reports.edit',
    Export = 'analytic-reports.export',
    ForwardToRole = 'analytic-reports.forward-to-role',
    ForwardToUserOrEmail = 'analytic-reports.forward-to-user-or-email',
    ScheduleToRole = 'analytic-reports.schedule-to-role',
    ScheduleToUserOrEmail = 'analytic-reports.schedule-to-user-or-email',
    Send = 'analytic-reports.send',
    Share = 'analytic-reports.share',
    View = 'analytic-reports.view',
}

enum AnalyticReportSettings {
    Edit = 'analytic-report-settings.edit',
    View = 'analytic-report-settings.view',
}

enum AnalyticScore {
    View = 'analytic-score.view',
}

enum AnalyticSVSocial {
    View = 'analytic-sv-social.view',
}

enum AnalyticTornado {
    View = 'analytic-tornado.view',
}

enum AnalyticTrafficInsights {
    View = 'analytic-traffic-insights.view',
}

enum AnalyticVOBReviewResponding {
    View = 'analytic-vob-review-responding.view',
}

enum AnalyticVOBReviewRespondingDashboard {
    View = 'analytic-vob-review-responding-dashboard.view',
}

enum AnalyticVOBConfiguration {
    Edit = 'analytic-vob-configuration.edit',
    View = 'analytic-vob-configuration.view',
}

enum AnalyticVOCIndustry {
    View = 'analytic-voc-industry.view',
}

enum AnalyticVOEPeople {
    View = 'analytic-voe-people.view',
}

enum AnalyticWordCloud {
    View = 'analytic-word-cloud.view',
}

enum AnalyticCompetitiveInsightsCompassLocationComparison {
    Add = 'analytic-ci-compass-location-comparison.add',
    Delete = 'analytic-ci-compass-location-comparison.delete',
    Edit = 'analytic-ci-compass-location-comparison.edit',
    View = 'analytic-ci-compass-location-comparison.view',
}

enum AnalyticCompetitiveInsightsCompassBrandComparison {
    Add = 'analytic-ci-compass-brand-comparison.add',
    Delete = 'analytic-ci-compass-brand-comparison.delete',
    Edit = 'analytic-ci-compass-brand-comparison.edit',
    View = 'analytic-ci-compass-brand-comparison.view',
}

enum AnalyticCompetitiveInsightsCompassExperienceAnalysis {
    View = 'analytic-ci-compass-experience-analysis.view',
}

enum AnalyticCompetitiveInsightsCompassCommentExploration {
    View = 'analytic-ci-compass-comment-exploration.view',
}

enum AnalyticCompetitiveInsightsCompassJourneyInsights {
    View = 'analytic-ci-compass-journey-insights.view',
}

enum AnalyticCompetitiveInsightsCompassSWOTReviews {
    View = 'analytic-ci-compass-swot-reviews.view',
}

enum AnalyticCompetitiveInsightsCompassSWOTWebSources {
    View = 'analytic-ci-compass-swot-web-sources.view',
}

enum AssetLibrary {
    View = 'asset-library.view',
}
enum CommandCenter {
    View = 'command-center.view',
}
enum CompetitiveInsightsBasic {
    View = 'competitive-insights-basic.view',
}

enum CompetitiveInsightsLocal {
    View = 'competitive-insights-local.view',
}

enum CompetitiveInsightsNational {
    View = 'competitive-insights-national.view',
}

enum Datastore {
    View = 'datastore.view',
}

enum DirectoryFinder {
    View = 'directory-finder.view',
}

enum DirectoryListings {
    OptOut = 'directory-listings.opt-out',
    View = 'directory-listings.view',
}

enum DirectoryListingsDuplicate {
    Approve = 'directory-listings-duplicate.approve',
    Edit = 'directory-listings-duplicate.edit',
    View = 'directory-listings-duplicate.view',
}

enum DirectoryListingPosts {
    Add = 'directory-listing-posts.add',
    Delete = 'directory-listing-posts.delete',
    Edit = 'directory-listing-posts.edit',
    View = 'directory-listing-posts.view',
}

enum DirectoryListingMappings {
    Add = 'directory-listing-mappings.add',
    Delete = 'directory-listing-mappings.delete',
    Edit = 'directory-listing-mappings.edit',
    View = 'directory-listing-mappings.view',
}

enum DirectoryListingSettings {
    Edit = 'directory-listing-settings.edit',
    View = 'directory-listing-settings.view',
}

enum DirectoryLocator {
    View = 'directory-locator.view',
}

enum DirectoryPages {
    View = 'directory-pages.view',
}

enum DirectoryProfileFields {
    Add = 'directory-profile-fields.add',
    Delete = 'directory-profile-fields.delete',
    Edit = 'directory-profile-fields.edit',
    View = 'directory-profile-fields.view',
}

enum DirectoryProfiles {
    Add = 'directory-profiles.add',
    Delete = 'directory-profiles.delete',
    Edit = 'directory-profiles.edit',
    Publish = 'directory-profiles.publish',
    View = 'directory-profiles.view',
    ForceSync = 'directory-profiles.force-sync',
}

enum DirectoryRichContent {
    Add = 'directory-rich-content.add',
    Delete = 'directory-rich-content.delete',
    Edit = 'directory-rich-content.edit',
    View = 'directory-rich-content.view',
}

enum DirectorySuggestions {
    Delete = 'directory-suggestions.delete',
    Edit = 'directory-suggestions.edit',
    View = 'directory-suggestions.view',
}

enum EngageDashboards {
    Edit = 'engage-dashboards.edit',
    ShareGuestLinks = 'engage-dashboards.share-guest-links',
    View = 'engage-dashboards.view',
}

enum EngageEngagements {
    Delete = 'engage-engagements.delete',
    View = 'engage-engagements.view',
    ViewAll = 'engage-engagements.view-all',
}

enum EngageIntegrations {
    Edit = 'engage-integrations.edit',
}

enum EngagePreferences {
    Edit = 'engage-preferences.edit',
}

enum EngageQueues {
    Edit = 'engage-queues.edit',
}

enum EngageReports {
    Edit = 'engage-reports.edit',
    Publish = 'engage-reports.publish',
    Run = 'engage-reports.run',
    Schedule = 'engage-reports.schedule',
    View = 'engage-reports.view',
}

enum EngageSegments {
    Edit = 'engage-segments.edit',
}

enum EngageTags {
    Edit = 'engage-tags.edit',
}

enum EngageStandardResponses {
    Edit = 'engage-standard-responses.edit',
}

enum GSRRatings {
    Add = 'gsr-ratings.add',
    Delete = 'gsr-ratings.delete',
    Edit = 'gsr-ratings.edit',
    Export = 'gsr-ratings.export',
    Import = 'gsr-ratings.import',
    Publish = 'gsr-ratings.publish',
    View = 'gsr-ratings.view',
}

enum HashtagGroup {
    Add = 'social-hashtag-group.add',
    Edit = 'social-hashtag-group.edit',
    Delete = 'social-hashtag-group.delete',
}

enum Integrations {
    Add = 'integrations.add',
    Admin = 'integrations.admin',
    CloneIntegration = 'integrations.clone-integration',
    Delete = 'integrations.delete',
    Edit = 'integrations.edit',
    ExecuteAdvancedScript = 'integrations.execute-advanced-script',
    ExportImportIntegration = 'integrations.export-import',
    ExportResults = 'integrations.export-results',
    Lookup = 'integrations.lookup',
    RunNow = 'integrations.run-now',
    TestMode = 'integrations.test-mode',
    View = 'integrations.view',
}

enum KioskReviews {
    Alert = 'kiosk-reviews.alert',
    Delete = 'kiosk-reviews.delete',
    Export = 'kiosk-reviews.export',
    Flag = 'kiosk-reviews.flag',
    ForwardToRole = 'kiosk-reviews.forward-to-role',
    ForwardToUserOrEmail = 'kiosk-reviews.forward-to-user-or-email',
    Publish = 'kiosk-reviews.publish',
    Read = 'kiosk-reviews.read',
    RequestReview = 'kiosk-reviews.request-review',
    View = 'kiosk-reviews.view',
}

enum KioskSettings {
    Edit = 'kiosk-settings.edit',
    View = 'kiosk-settings.view',
}

enum KioskResponses {
    Add = 'kiosk-responses.add',
    View = 'kiosk-responses.view',
    Edit = 'kiosk-responses.edit',
    Delete = 'kiosk-responses.delete',
    Approve = 'kiosk-responses.approve',
    SoftDelete = 'kiosk-responses.soft-delete',
}

enum KioskResponseSettings {
    Edit = 'kiosk-response-settings.edit',
    View = 'kiosk-response-settings.view',
}

enum ListenAlerts {
    View = 'listen-alerts.view',
}

enum ListenDashboards {
    Edit = 'listen-dashboards.edit',
    ShareGuestLinks = 'listen-dashboards.share-guest-links',
    View = 'listen-dashboards.view',
}

enum ListenDashboardTemplates {
    Edit = 'listen-dashboard-templates.edit',
}

enum ListenHistoricalData {
    Add = 'listen-historical-data.add',
}

enum ListenIntegrations {
    Edit = 'listen-integrations.edit',
}

enum ListenMentions {
    ChangeSentiment = 'listen-mentions.change-sentiment',
    CreateNotes = 'listen-mentions.create-notes',
    Delete = 'listen-mentions.delete',
    Reply = 'listen-mentions.reply',
    ShareGuestLinks = 'listen-mentions.share-guest-links',
}

enum ListenMonitors {
    Edit = 'listen-monitors.edit',
    View = 'listen-monitors.view',
}

enum ListenPreferences {
    Edit = 'listen-preferences.edit',
}

enum ListenReports {
    Edit = 'listen-reports.edit',
    Publish = 'listen-reports.publish',
    Run = 'listen-reports.run',
    Schedule = 'listen-reports.schedule',
    View = 'listen-reports.view',
}

enum ListenSegments {
    Edit = 'listen-segments.edit',
}

enum ListenTags {
    Apply = 'listen-tags.apply',
    Edit = 'listen-tags.edit',
}

enum MessagingAutomatedResponses {
    Add = 'messaging-automated-responses.add',
    Delete = 'messaging-automated-responses.delete',
    Edit = 'messaging-automated-responses.edit',
    View = 'messaging-automated-responses.view',
}

enum MessagingCampaigns {
    Add = 'messaging-campaigns.add',
    Delete = 'messaging-campaigns.delete',
    Edit = 'messaging-campaigns.edit',
    View = 'messaging-campaigns.view',
}

enum MessagingInboxConversations {
    ClosingReasonRequired = 'messaging-inbox-conversations.closing-reason-required',
    ClosingTagRequired = 'messaging-inbox-conversations.closing-tag-required',
    View = 'messaging-inbox-conversations.view',
}

enum MessagingInboxResponses {
    Add = 'messaging-inbox-responses.add',
    Approve = 'messaging-inbox-responses.approve',
    Delete = 'messaging-inbox-responses.delete',
    Edit = 'messaging-inbox-responses.edit',
    Hide = 'messaging-inbox-responses.hide',
}

enum NewReportingPlatformDashboard {
    View = 'analytic-reporting-dashboard.view',
    Edit = 'analytic-reporting-dashboard.edit',
    Create = 'analytic-reporting-dashboard.create',
    Delete = 'analytic-reporting-dashboard.delete',
}

enum NewReportingPlatformReport {
    View = 'analytic-reporting-report.view',
    Edit = 'analytic-reporting-report.edit',
    Share = 'analytic-reporting-report.share',
    Schedule = 'analytic-reporting-report.schedule',
    Download = 'analytic-reporting-report.download',
}

enum PlatformAutomatedResponses {
    Add = 'platform-automated-responses.add',
    Delete = 'platform-automated-responses.delete',
    Edit = 'platform-automated-responses.edit',
    Export = 'platform-automated-responses.export',
    Import = 'platform-automated-responses.import',
    View = 'platform-automated-responses.view',
}

enum PlatformAutomationRules {
    Add = 'platform-automation-rules.add',
    Delete = 'platform-automation-rules.delete',
    Edit = 'platform-automation-rules.edit',
    View = 'platform-automation-rules.view',
}

enum PlatformCensorData {
    Add = 'platform-censor-data.add',
    Delete = 'platform-censor-data.delete',
    Edit = 'platform-censor-data.edit',
    View = 'platform-censor-data.view',
}

enum PlatformCompetitorLocations {
    Add = 'platform-competitor-locations.add',
    Delete = 'platform-competitor-locations.delete',
    Edit = 'platform-competitor-locations.edit',
    View = 'platform-competitor-locations.view',
}

enum PlatformCredentials {
    Add = 'platform-credentials.add',
    AddAll = 'platform-credentials.add-all',
    Alert = 'platform-credentials.alert',
    Delete = 'platform-credentials.delete',
    DeleteAll = 'platform-credentials.delete-all',
    Edit = 'platform-credentials.edit',
    EditAll = 'platform-credentials.edit-all',
    View = 'platform-credentials.view',
    ViewAll = 'platform-credentials.view-all',
}

enum ManagedServicesCredentials {
    View = 'managed-services-credentials.view',
}

enum PlatformCustomTabs {
    View = 'platform-custom-tabs.view',
}

enum PlatformCustomers {
    Add = 'platform-customers.add',
    Delete = 'platform-customers.delete',
    Edit = 'platform-customers.edit',
    Export = 'platform-customers.export',
    Import = 'platform-customers.import',
    View = 'platform-customers.view',
}

enum PlatformDashboards {
    Add = 'platform-dashboards.add',
    Delete = 'platform-dashboards.delete',
    Edit = 'platform-dashboards.edit',
    Export = 'platform-dashboards.export',
    ForwardToRole = 'platform-dashboards.forward-to-role',
    ForwardToUserOrEmail = 'platform-dashboards.forward-to-user-or-email',
    ScheduleToRole = 'platform-dashboards.schedule-to-role',
    ScheduleToUserOrEmail = 'platform-dashboards.schedule-to-user-or-email',
    Send = 'platform-dashboards.send',
    Share = 'platform-dashboards.share',
    View = 'platform-dashboards.view',
}

enum PlatformDataProtection {
    Delete = 'platform-data-protection.delete',
    View = 'platform-data-protection.view',
}

enum PlatformEducation {
    View = 'platform-education.view',
}

enum PlatformEmployeeAttribution {
    Add = 'platform-employee-attribution.add',
    Delete = 'platform-employee-attribution.delete',
    View = 'platform-employee-attribution.view',
}

enum PlatformHelp {
    Edit = 'platform-help.edit',
    View = 'platform-help.view',
}

enum PlatformImportJobs {
    Cancel = 'platform-import-jobs.cancel',
    ImportUser = 'platform-import-jobs.import-user',
    View = 'platform-import-jobs.view',
}

enum PlatformInboxAttachments {
    Add = 'platform-inbox-attachments.add',
    Delete = 'platform-inbox-attachments.delete',
}

enum PlatformInboxConversations {
    Add = 'platform-inbox-conversations.add',
    Assign = 'platform-inbox-conversations.assign',
    Close = 'platform-inbox-conversations.close',
    Delete = 'platform-inbox-conversations.delete',
    Flag = 'platform-inbox-conversations.flag',
    Read = 'platform-inbox-conversations.read',
}

enum PlatformInboxSettings {
    Edit = 'platform-inbox-settings.edit',
    View = 'platform-inbox-settings.view',
}

enum PlatformInternalEmails {
    Send = 'platform-internal-emails.send',
}

enum PlatformLocations {
    Add = 'platform-locations.add',
    Delete = 'platform-locations.delete',
    Edit = 'platform-locations.edit',
    View = 'platform-locations.view',
}

enum PlatformMacros {
    Add = 'platform-macros.add',
    AddTenant = 'platform-macros.add-tenant',
    Delete = 'platform-macros.delete',
    DeleteTenant = 'platform-macros.delete-tenant',
    Edit = 'platform-macros.edit',
    EditTenant = 'platform-macros.edit-tenant',
    View = 'platform-macros.view',
    ViewSystem = 'platform-macros.view-system',
    ViewTenant = 'platform-macros.view-tenant',
}

enum PlatformManagedServices {
    View = 'platform-managed-services.view',
}

enum PlatformMyAccount {
    Edit = 'platform-my-account.edit',
    View = 'paltform-my-account.view',
}

enum PlatformNotifications {
    Add = 'platform-notifications.add',
    Delete = 'platform-notifications.delete',
    Edit = 'platform-notifications.edit',
    Send = 'platform-notifications.send',
    View = 'platform-notifications.view',
}

enum PlatformNuviSettings {
    View = 'platform-nuvi-settings.view',
}

enum PlatformObjectPrivileges {
    Add = 'platform-object-privileges.add',
    Edit = 'platform-object-privileges.edit',
    GlobalShare = 'platform-object-privileges.global-share',
    Manage = 'platform-object-privileges.manage',
    SetDefault = 'platform-object-privileges.set-default',
    View = 'platform-object-privileges.view',
}

enum PlatformPII {
    ViewPublic = 'platform-pii.view-public',
    ViewSensitive = 'platform-pii.view-sensitive',
}

enum PlatformRoles {
    Add = 'platform-roles.add',
    Delete = 'platform-roles.delete',
    Edit = 'platform-roles.edit',
    View = 'platform-roles.view',
}

enum PlatformSources {
    View = 'platform-sources.view',
}

enum PlatformSuggestedResponses {
    View = 'platform-suggested-responses.view',
}

enum PlatformSuggestedResponseSettings {
    Edit = 'platform-suggested-response-settings.edit',
    View = 'platform-suggested-response-settings.view',
}

enum PlatformTags {
    Add = 'platform-tags.add',
    Delete = 'platform-tags.delete',
    Edit = 'platform-tags.edit',
    View = 'platform-tags.view',
}

enum PlatformTemplates {
    Add = 'platform-templates.add',
    AddTenant = 'platform-templates.add-tenant',
    Delete = 'platform-templates.delete',
    DeleteTenant = 'platform-templates.delete-tenant',
    Edit = 'platform-templates.edit',
    EditTenant = 'platform-templates.edit-tenant',
    View = 'platform-templates.view',
    ViewSystem = 'platform-templates.view-system',
    ViewTenant = 'platform-templates.view-tenant',
}

enum PlatformTenants {
    Edit = 'platform-tenants.edit',
    View = 'platform-tenants.view',
}

enum PlatformTestimonials {
    Edit = 'platform-testimonials.edit',
    View = 'platform-testimonials.view',
}

enum PlatformUI {
    Login = 'platform-ui.login',
}

enum PlatformUsers {
    Add = 'platform-users.add',
    Delete = 'platform-users.delete',
    Edit = 'platform-users.edit',
    Export = 'platform-users.export',
    Pause = 'platform-users.pause',
    View = 'platform-users.view',
}

enum PlatformUTMParams {
    Add = 'platform-utm-params.add',
    Delete = 'platform-utm-params.delete',
    Edit = 'platform-utm-params.edit',
    View = 'platform-utm-params.view',
}

enum PlatformWidgets {
    Add = 'platform-widgets.add',
    AddTenant = 'platform-widgets.add-tenant',
    Delete = 'platform-widgets.delete',
    DeleteTenant = 'platform-widgets.delete-tenant',
    Edit = 'platform-widgets.edit',
    EditTenant = 'platform-widgets.edit-tenant',
    View = 'platform-widgets.view',
    ViewTenant = 'platform-widgets.view-tenant',
}

enum PlatformPrivilegedAccessManagementTags {
    Add = 'platform-privileged-access-management-tags.add',
    Delete = 'platform-privileged-access-management-tags.delete',
    Edit = 'platform-privileged-access-management-tags.edit',
    View = 'platform-privileged-access-management-tags.view',
}

enum PlatformPrivilegedAgencies {
    View = 'platform-privileged-agencies.view',
}

enum PlatformPrivilegedCompetitorLocations {
    Export = 'platform-privileged-competitor-locations.export',
    Import = 'platform-privileged-competitor-locations.import',
}

enum PlatformPrivilegedCredentials {
    Export = 'platform-privileged-credentials.export',
    Import = 'platform-privileged-credentials.import',
}

enum PlatformPrivilegedDefaultRoles {
    View = 'platform-privileged-default-roles.view',
}

enum PlatformPrivilegedDirectoryListings {
    OnboardSOT = 'platform-privileged-directory-listings.onboard-sot',
}

enum PlatformPrivilegedFeatureFlags {
    Add = 'platform-privileged-feature-flags.add',
    Delete = 'platform-privileged-feature-flags.delete',
    Edit = 'platform-privileged-feature-flags.edit',
    View = 'platform-privileged-feature-flags.view',
}

enum PlatformPrivilegedLinkShortener {
    Add = 'platform-privileged-link-shortener.add',
    Delete = 'platform-privileged-link-shortener.delete',
    Edit = 'platform-privileged-link-shortener.edit',
    View = 'platform-privileged-link-shortener.view',
}

enum PlatformPrivilegedLocations {
    Export = 'platform-privileged-locations.export',
    Import = 'platform-privileged-locations.import',
}

enum PlatformPrivilegedManagedServices {
    Export = 'platform-privileged-managed-services.export',
    Import = 'platform-privileged-managed-services.import',
}

enum PlatformPrivilegedModules {
    View = 'platform-privileged-modules.view',
}

enum PlatformPrivilegedReports {
    View = 'platform-privileged-reports.view',
}

enum PlatformPrivilegedRest2Thrift {
    Edit = 'platform-privileged-rest2thrift.edit',
    View = 'platform-privileged-rest2thrift.view',
}

enum PlatformPrivilegedSKUs {
    Add = 'platform-privileged-skus.add',
    Delete = 'platform-privileged-skus.delete',
    Edit = 'platform-privileged-skus.edit',
    View = 'platform-privileged-skus.view',
}

enum PlatformPrivilegedSources {
    View = 'platform-privileged-sources.view',
}

enum PlatformPrivilegedAgencyRoles {
    Add = 'platform-privileged-agency-roles.add',
    Delete = 'platform-privileged-agency-roles.delete',
    Edit = 'platform-privileged-agency-roles.edit',
    View = 'platform-privileged-agency-roles.view',
}

enum PlatformPrivilegedAgencyUsers {
    Add = 'platform-privileged-agency-users.add',
    Delete = 'platform-privileged-agency-users.delete',
    Edit = 'platform-privileged-agency-users.edit',
    Pause = 'platform-privileged-agency-users.pause',
    View = 'platform-privileged-agency-users.view',
}

enum AgencyUserProvisioner {
    Add = 'platform-user-management-agency-users.add',
    Delete = 'platform-user-management-agency-users.delete',
    Edit = 'platform-user-management-agency-users.edit',
    Pause = 'platform-user-management-agency-users.pause',
    View = 'platform-user-management-agency-users.view',
}

enum ApiKeyTenantProvisioner {
    Add = 'platform-api-key.add',
    Delete = 'platform-api-key.delete',
    Edit = 'platform-api-key.edit',
    Pause = 'platform-api-key.pause',
    View = 'platform-api-key.view',
}

enum ApiKeyAgencyProvisioner {
    Add = 'platform-agency-api-key.add',
    Delete = 'platform-agency-api-key.delete',
    Edit = 'platform-agency-api-key.edit',
    Pause = 'platform-agency-api-key.pause',
    View = 'platform-agency-api-key.view',
}

enum PlatformPrivilegedTenants {
    Add = 'platform-privileged-tenants.add',
    Clone = 'platform-privileged-tenants.clone',
    Delete = 'platform-privileged-tenants.delete',
    Edit = 'platform-privileged-tenants.edit',
    Manage = 'platform-privileged-tenants.manage',
    Pause = 'platform-privileged-tenants.pause',
    Provision = 'platform-privileged-tenants.provision',
    ProvisionBeta = 'platform-privileged-tenants.provision-beta',
    Terminate = 'platform-privileged-tenants.terminate',
    View = 'platform-privileged-tenants.view',
    ViewDemo = 'platform-privileged-tenants.view-demo',
}

enum PlatformPrivilegedUsers {
    Impersonate = 'platform-privileged-users.impersonate',
    Import = 'platform-privileged-users.import',
    Support = 'platform-privileged-users.support',
}

enum PlatformSuperPrivilegedAgencies {
    Add = 'platform-super-privileged-agencies.add',
    Edit = 'platform-super-privileged-agencies.edit',
    Pause = 'platform-super-privileged-agencies.pause',
    View = 'platform-super-privileged-agencies.view',
}

enum PublishDashboards {
    Edit = 'publish-dashboards.edit',
    ShareGuestLinks = 'publish-dashboards.share-guest-links',
    View = 'publish-dashboards.view',
}

enum PublishGallery {
    Edit = 'publish-gallery.edit',
    EditAlbums = 'publish-gallery.edit-albums',
    ShareAlbums = 'publish-gallery.share-albums',
}

enum PublishIntegrations {
    Edit = 'publish-integrations.edit',
}

enum PublishPosts {
    Add = 'publish-posts.add',
    EditLabels = 'publish-posts.edit-labels',
    MassPublish = 'publish-posts.mass-publish',
    View = 'publish-posts.view',
}

enum PublishPreferences {
    Edit = 'publish-preferences.edit',
}

enum PublishReports {
    Edit = 'publish-reports.edit',
    Publish = 'publish-reports.publish',
    Run = 'publish-reports.run',
    Schedule = 'publish-reports.schedule',
    View = 'publish-reports.view',
}

enum PublishSegments {
    Edit = 'publish-segments.edit',
}

enum PublishSmartSocial {
    Edit = 'publish-smart-social.edit',
}

enum PublishWorkflows {
    Bypass = 'publish-workflows.bypass',
    Edit = 'publish-workflows.edit',
    View = 'publish-workflows.view',
    ViewTasks = 'publish-workflows.view-tasks',
}

enum QA {
    Alert = 'qa.alert',
    Export = 'qa.export',
    Flag = 'qa.flag',
    ForwardToRole = 'qa.forward-to-role',
    ForwardToUserOrEmail = 'qa.forward-to-user-or-email',
    Read = 'qa.read',
    View = 'qa.view',
}

enum QAResponses {
    Add = 'qa-responses.add',
    Approve = 'qa-responses.approve',
    Delete = 'qa-responses.delete',
    Edit = 'qa-responses.edit',
    View = 'qa-responses.view',
    SoftDelete = 'qa-responses.soft-delete',
}

enum RepIQReviews {
    Add = 'rep-iq-reviews.add',
    Delete = 'rep-iq-reviews.delete',
    Edit = 'rep-iq-reviews.edit',
    Export = 'rep-iqt-reviews.export',
    Share = 'rep-iq-reviews.share',
    View = 'rep-iq-reviews.view',
}

enum RepConnectAdmin {
    Admin = 'rep-connect.admin',
}

enum RepScoreImpactReport {
    View = 'score-rep-score-impact-report.view',
}

enum Requests {
    BulkSend = 'requests.bulk-send',
    Resend = 'requests.resend',
    Send = 'requests.send',
    SendCopy = 'requests.send-copy',
    SendSMS = 'requests.send-sms',
    SendTest = 'requests.send-test',
    SendSnapAndEngage = 'requests.send-snap-and-engage',
    View = 'requests.view',
}

enum RequestLeaderboard {
    Export = 'request-leaderboard.export',
    View = 'request-leaderboard.view',
}

enum RequestMetrics {
    Export = 'request-metrics.export',
    View = 'request-metrics.view',
}

enum RequestSettings {
    Edit = 'request-settings.edit',
    Unsubscribe = 'request-settings.unsubscribe',
    View = 'request-settings.view',
}

enum RequestTemplates {
    Add = 'request-templates.add',
    AddTenant = 'request-templates.add-tenant',
    Delete = 'request-templates.delete',
    DeleteTenant = 'request-templates.delete-tenant',
    Edit = 'request-templates.edit',
    EditTenant = 'request-templates.edit-tenant',
    View = 'request-templates.view',
    ViewTenant = 'request-templates.view-tenant',
}

enum Reviews {
    Alert = 'reviews.alert',
    Export = 'reviews.export',
    Flag = 'reviews.flag',
    ForwardToRole = 'reviews.forward-to-role',
    ForwardToUserOrEmail = 'reviews.forward-to-user-or-email',
    Publish = 'reviews.publish',
    Read = 'reviews.read',
    Unified = 'reviews.unified',
    View = 'reviews.view',
}

enum ReviewAttributions {
    Add = 'review-attributions.add',
    Delete = 'review-attributions.delete',
    View = 'review-attributions.view',
}

enum ReviewInboxConversations {
    ClosingReasonRequired = 'review-inbox-conversations.closing-reason-required',
    ClosingTagRequired = 'review-inbox-conversations.closing-tag-required',
    View = 'review-inbox-conversations.view',
}

enum ReviewInboxResponses {
    Add = 'review-inbox-responses.add',
    Delete = 'review-inbox-responses.delete',
    Edit = 'review-inbox-responses.edit',
    Hide = 'review-inbox-responses.hide',
}

enum ReviewSettings {
    Edit = 'review-settings.edit',
    View = 'review-settings.view',
}

enum ReviewResponses {
    Add = 'review-responses.add',
    View = 'review-responses.view',
    Edit = 'review-responses.edit',
    Delete = 'review-responses.delete',
    Approve = 'review-responses.approve',
    SoftDelete = 'review-responses.soft-delete',
    AIResponses = 'review-responses.ai-responses',
}

enum ReviewResponseSettings {
    Edit = 'review-response-settings.edit',
    View = 'review-response-settings.view',
}

enum ScoreBasicScore {
    View = 'score-basic-score.view',
}

enum ScorePrescriptiveScore {
    View = 'score-prescriptive-score.view',
}

enum ScoreTargetsScore {
    Add = 'score-targets-score.add',
    Delete = 'score-targets-score.delete',
    Edit = 'score-targets-score.edit',
    View = 'score-targets-score.view',
}

enum SearchInsightAnalytics {
    View = 'search-insight-analytics.view',
}

enum SearchInsightAnalyticSettings {
    Edit = 'search-insight-analytic-settings.edit',
    View = 'search-insight-analytic-settings.view',
}

enum SocialCampaigns {
    Add = 'social-campaigns.add',
    Alert = 'social-campaigns.alert',
    Delete = 'social-campaigns.delete',
    Edit = 'social-campaigns.edit',
    Enroll = 'social-campaigns.enroll',
    View = 'social-campaigns.view',
}

enum SocialCampaignMetrics {
    View = 'social-campaign-metrics.view',
}

enum SocialCurationQueues {
    Add = 'social-curation-queues.add',
    View = 'social-curation-queues.view',
}

enum SocialCurationSettings {
    Edit = 'social-curation-settings.edit',
    View = 'social-curation-settings.view',
}

enum SocialCurationTasks {
    View = 'social-curation-tasks.view',
}

enum SocialInboxConversations {
    ClosingReasonRequired = 'social-inbox-conversations.closing-reason-required',
    ClosingTagRequired = 'social-inbox-conversations.closing-tag-required',
    View = 'social-inbox-conversations.view',
}

enum SocialInboxResponses {
    Add = 'social-inbox-responses.add',
    Delete = 'social-inbox-responses.delete',
    Edit = 'social-inbox-responses.edit',
    Hide = 'social-inbox-responses.hide',
}

enum SocialListeningLivestream {
    View = 'social-listening-livestream.view',
}

enum SocialListeningMetrics {
    View = 'social-listening-metrics.view',
}

enum SocialMetrics {
    View = 'social-metrics.view',
}

enum SocialPosts {
    Delete = 'social-posts.delete',
    Flag = 'social-posts.flag',
    View = 'social-posts.view',
}

enum SocialResponses {
    Add = 'social-responses.add',
    AddPrivate = 'social-responses.add-private',
    Delete = 'social-responses.delete',
    Hide = 'social-responses.hide',
    View = 'social-responses.view',
}

enum SocialPublishPosts {
    Add = 'social-publish-posts.add',
    Approve = 'social-publish-posts.approve',
    ApproveAuto = 'social-publish-posts.approve-auto',
    Delete = 'social-publish-posts.delete',
    Edit = 'social-publish-posts.edit',
    TargetAudience = 'social-publish-posts.target-audience',
    View = 'social-publish-posts.view',
}

enum SocialRepoContent {
    Add = 'social-repo-content.add',
    AddGlobal = 'social-repo-content.add-global',
    Delete = 'social-repo-content.delete',
    Edit = 'social-repo-content.edit',
    View = 'social-repo-content.view',
}

enum SocialRepoFeeds {
    Add = 'social-repo-feeds.add',
    Delete = 'social-repo-feeds.delete',
    Edit = 'social-repo-feeds.edit',
    View = 'social-repo-feeds.view',
}

enum SocialRepoTags {
    Add = 'social-repo-tags.add',
    Delete = 'social-repo-tags.delete',
    Edit = 'social-repo-tags.edit',
    View = 'social-repo-tags.view',
}

enum SurveyInboxConversations {
    ClosingReasonRequired = 'survey-inbox-conversations.closing-reason-required',
    ClosingTagRequired = 'survey-inbox-conversations.closing-tag-required',
    View = 'survey-inbox-conversations.view',
}

enum SurveyInboxResponses {
    Add = 'survey-inbox-responses.add',
    Delete = 'survey-inbox-responses.delete',
    Edit = 'survey-inbox-responses.edit',
    SMSResponding = 'survey-inbox-responses.sms-responding',
    SoftDelete = 'survey-inbox-responses.soft-delete',
    View = 'survey-inbox-responses.view',
}

enum SurveyLegacyResults {
    Alert = 'survey-legacy-results.alert',
    Delete = 'survey-legacy-results.delete',
    Export = 'survey-legacy-results.export',
    Flag = 'survey-legacy-results.flag',
    ForwardToRole = 'survey-legacy-results.forward-to-role',
    ForwardToUserOrEmail = 'survey-legacy-results.forward-to-user-or-email',
    Publish = 'survey-legacy-results.publish',
    Read = 'survey-legacy-results.read',
    Resurvey = 'survey-legacy-results.resurvey',
    View = 'survey-legacy-results.view',
}

enum SurveyLegacyResponses {
    Add = 'survey-legacy-responses.add',
    View = 'survey-legacy-responses.view',
    Edit = 'survey-legacy-responses.edit',
    Delete = 'survey-legacy-responses.delete',
    Approve = 'survey-legacy-responses.approve',
    SmsResponding = 'survey-legacy-responses.sms-responding',
    SoftDelete = 'survey-legacy-responses.soft-delete',
}

enum SurveyResults {
    Alert = 'survey-results.alert',
    Delete = 'survey-results.delete',
    Export = 'survey-results.export',
    Flag = 'survey-results.flag',
    ForwardToRole = 'survey-results.forward-to-role',
    ForwardToUserOrEmail = 'survey-results.forward-to-user-or-email',
    Publish = 'survey-results.publish',
    Read = 'survey-results.read',
    Resurvey = 'survey-results.resurvey',
    View = 'survey-results.view',
}

enum SurveySettings {
    Edit = 'survey-settings.edit',
    View = 'survey-settings.view',
}

enum SurveyResponses {
    Add = 'survey-responses.add',
    View = 'survey-responses.view',
    Edit = 'survey-responses.edit',
    Delete = 'survey-responses.delete',
    Approve = 'survey-responses.approve',
    SoftDelete = 'survey-responses.soft-delete',
}

enum SurveyResponseSettings {
    Edit = 'survey-response-settings.edit',
    View = 'survey-response-settings.view',
}

enum SurveyTemplates {
    Add = 'survey-templates.add',
    Delete = 'survey-templates.delete',
    Edit = 'survey-templates.edit',
    View = 'survey-templates.view',
}

enum SurveySummaries {
    Export = 'survey-summaries.export',
    View = 'survey-summaries.view',
}

enum Survey3BasicTemplates {
    Add = 'survey3-basic-templates.add',
    Delete = 'survey3-basic-templates.delete',
    Edit = 'survey3-basic-templates.edit',
    View = 'survey3-basic-templates.view',
}

enum Survey3Conversational {
    View = 'survey3-conversational.view',
}

enum Survey3Results {
    Delete = 'survey3-results.delete',
    Export = 'survey3-results.export',
    Flag = 'survey3-results.flag',
    ForwardToRole = 'survey3-results.forward-to-role',
    ForwardToUserOrEmail = 'survey3-results.forward-to-user-or-email',
    Publish = 'survey3-results.publish',
    Read = 'survey3-results.read',
    Resurvey = 'survey3-results.resurvey',
    View = 'survey3-results.view',
    Import = 'survey3-results.import',
}

enum Survey3ResultsFeedUpdate {
    View = 'survey3-results-feed-update.view',
}

enum Survey3Settings {
    Edit = 'survey3-settings.edit',
    View = 'survey3-settings.view',
}

enum Survey3Responses {
    Add = 'survey3-responses.add',
    View = 'survey3-responses.view',
    Edit = 'survey3-responses.edit',
    Delete = 'survey3-responses.delete',
    Approve = 'survey3-responses.approve',
    SoftDelete = 'survey3-responses.soft-delete',
    SmsResponding = 'survey3-responses.sms-responding',
    RespondAsUser = 'survey3-responses.respond-as-user',
    RespondOptionDefaultToUser = 'survey3-responses.respond-option-default-to-user',
}

enum Survey3SharedFolders {
    Add = 'survey3-shared-folders.add',
    Delete = 'survey3-shared-folders.delete',
    Edit = 'survey3-shared-folders.edit',
}

enum Survey3ResponseManager {
    View = 'survey3-response-manager.view',
}

enum Survey3ResponseSettings {
    Edit = 'survey3-response-settings.edit',
    View = 'survey3-response-settings.view',
}

enum Survey3Templates {
    Add = 'survey3-templates.add',
    CreateLink = 'survey3-templates.create-link',
    Delete = 'survey3-templates.delete',
    Edit = 'survey3-templates.edit',
    AdvancedEdit = 'survey3-templates.edit-all',
    View = 'survey3-templates.view',
}

enum Survey3FraudProtection {
    Edit = 'survey3-fraud-protection.edit',
    View = 'survey3-fraud-protection.view',
}

enum Survey3Summaries {
    Export = 'survey3-summaries.export',
    View = 'survey3-summaries.view',
}

enum Tasks {
    Add = 'tasks.add',
    Approve = 'tasks.approve',
    Dispose = 'tasks.dispose',
    Edit = 'tasks.edit',
    Manage = 'tasks.manage',
    Moderate = 'tasks.moderate',
    Monitor = 'tasks.monitor',
    Post = 'tasks.post',
    Request = 'tasks.request',
    Respond = 'tasks.respond',
    View = 'tasks.view',
}

enum TaskActivities {
    Add = 'task-activities.add',
    View = 'task-activities.view',
}

enum TaskContacts {
    Add = 'task-contacts.add',
    Delete = 'task-contacts.delete',
    Edit = 'task-contacts.edit',
    View = 'task-contacts.view',
}

enum TaskDetails {
    View = 'task-details.view',
}

enum TaskNotes {
    Add = 'task-notes.add',
    Delete = 'task-notes.delete',
    Edit = 'task-notes.edit',
    View = 'task-notes.view',
}

enum TaskSettings {
    Edit = 'task-settings.edit',
    View = 'task-settings.view',
}

enum Tickets {
    Add = 'tickets.add',
    AlertRatingOnly = 'tickets.alert-rating-only',
    Assign = 'tickets.assign',
    ChangeCustomDefinition = 'tickets.change-custom-definition',
    Close = 'tickets.close',
    CloseExplanationRequired = 'tickets.close-explanation-required',
    Delete = 'tickets.delete',
    Edit = 'tickets.edit',
    EditCloseDate = 'tickets.edit-close-date',
    Export = 'tickets.export',
    Postpone = 'tickets.postpone',
    Tag = 'tickets.tag',
    CloseTagRequired = 'tickets.close-tag-required',
    View = 'tickets.view',
    ViewCustomFilters = 'tickets.view-custom-filters',
    ViewHistory = 'tickets.view-history',
    ViewSystemTagsAndTickets = 'tickets.view-system-tags',
    EditManualTicket = 'tickets.edit-manual',
    Clone = 'tickets.clone',
    EditSurveyTicket = 'tickets.edit-survey-ticket',
    EditCloseBackDate = 'tickets.edit-close-back-date',
    EditExplainCloseBackDate = 'tickets.edit-explain-close-back-date',
}

export const OPTUM_TENENTS = [184078];

enum TicketEscalations {
    Add = 'ticket-escalations.add',
    Delete = 'ticket-escalations.delete',
    Edit = 'ticket-escalations.edit',
    View = 'ticket-escalations.view',
}

enum TicketClosingReasons {
    Add = 'ticket-closing-reasons.add',
    Delete = 'ticket-closing-reasons.delete',
    Edit = 'ticket-closing-reasons.edit',
    View = 'ticket-closing-reasons.view',
}

enum TicketCustomDefinitions {
    Add = 'ticket-custom-definitions.add',
    Delete = 'ticket-custom-definitions.delete',
    Edit = 'ticket-custom-definitions.edit',
    View = 'ticket-custom-definitions.view',
}

enum TicketAttachments {
    Add = 'ticket-attachments.add',
    Delete = 'ticket-attachments.delete',
    Edit = 'ticket-attachments.edit',
    View = 'ticket-attachments.view',
}

enum TicketNotes {
    Add = 'ticket-notes.add',
    Delete = 'ticket-notes.delete',
    Edit = 'ticket-notes.edit',
    View = 'ticket-notes.view',
}

enum TicketPII {
    ViewPublic = 'ticket-pii.view-public',
    ViewSensitive = 'ticket-pii.view-sensitive',
}

enum TicketQueues {
    Add = 'ticket-queues.add',
    Delete = 'ticket-queues.delete',
    Edit = 'ticket-queues.edit',
    View = 'ticket-queues.view',
}

enum TicketRootCauses {
    Add = 'ticket-root-causes.add',
    Delete = 'ticket-root-causes.delete',
    Edit = 'ticket-root-causes.edit',
    View = 'ticket-root-causes.view',
}

enum TicketRules {
    Add = 'ticket-rules.add',
    Alert = 'ticket-rules.alert',
    Delete = 'ticket-rules.delete',
    Edit = 'ticket-rules.edit',
    View = 'ticket-rules.view',
}

enum TicketStages {
    Add = 'ticket-stages.add',
    Delete = 'ticket-stages.delete',
    Edit = 'ticket-stages.edit',
    View = 'ticket-stages.view',
}

enum TicketTags {
    Add = 'ticket-tags.add',
    Delete = 'ticket-tags.delete',
    Edit = 'ticket-tags.edit',
    View = 'ticket-tags.view',
}

enum TicketPrivilegedTickets {
    Manage = 'ticket-privileged-tickets.manage',
    View = 'ticket-privileged-tickets.view',
}

enum ActionPlans {
    Add = 'action-plans.add',
    Assign = 'action-plans.assign',
    Close = 'action-plans.close',
    Delete = 'action-plans.delete',
    Edit = 'action-plans.edit',
    Postpone = 'action-plans.postpone',
    Tag = 'action-plans.tag',
    View = 'action-plans.view',
    ViewHistory = 'action-plans.view-history',
}

enum ActionPlanEscalations {
    Add = 'action-plan-escalations.add',
    Delete = 'action-plan-escalations.delete',
    Edit = 'action-plan-escalations.edit',
    View = 'action-plan-escalations.view',
}

enum ActionPlanAttachments {
    Add = 'action-plan-attachments.add',
    Delete = 'action-plan-attachments.delete',
    Edit = 'action-plan-attachments.edit',
    View = 'action-plan-attachments.view',
}

enum ActionPlanNotes {
    Add = 'action-plan-notes.add',
    Delete = 'action-plan-notes.delete',
    Edit = 'action-plan-notes.edit',
    View = 'action-plan-notes.view',
}

enum ActionPlanPII {
    ViewPublic = 'action-plan-pii.view-public',
    ViewSensitive = 'action-plan-pii.view-sensitive',
}

enum ActionPlanRules {
    Add = 'action-plan-rules.add',
    Delete = 'action-plan-rules.delete',
    Edit = 'action-plan-rules.edit',
    View = 'action-plan-rules.view',
}

enum ActionPlanStages {
    Add = 'action-plan-stages.add',
    Delete = 'action-plan-stages.delete',
    Edit = 'action-plan-stages.edit',
    View = 'action-plan-stages.view',
}

enum ActionPlanTags {
    Add = 'action-plan-tags.add',
    Delete = 'action-plan-tags.delete',
    Edit = 'action-plan-tags.edit',
    View = 'action-plan-tags.view',
}

enum ActionPlanTeams {
    Add = 'action-plan-teams.add',
    Delete = 'action-plan-teams.delete',
    Edit = 'action-plan-teams.edit',
    View = 'action-plan-teams.view',
}

enum AutoFindResults {
    Accept = 'platform-auto-find-results.accept',
    Reject = 'platform-auto-find-results.reject',
    Trigger = 'platform-auto-find-results.trigger',
    View = 'platform-auto-find-results.view',
    Undo = 'platform-auto-find-results.undo',
}

enum NuviSocial {
    Operate = 'brand-social-agency-strategy.operate-ticket',
    Approve = 'brand-social-agency-strategy.approve',
}

export const ActionId: Record<string, Record<string, string>> = {
    ActionPlans,
    ActionPlanAttachments,
    ActionPlanEscalations,
    ActionPlanNotes,
    ActionPlanPII,
    ActionPlanRules,
    ActionPlanStages,
    ActionPlanTags,
    ActionPlanTeams,
    AdCampaigns,
    AdMetrics,
    AdPosts,
    AdSettings,
    AdPrivilegedCampaigns,
    AgencyActions,
    AnalyticAIO,
    AnalyticARMResponseMonitoring,
    AnalyticARMResponseMonitoringUsers,
    AnalyticARMResponseInsights,
    AnalyticARMPresenceDashboard,
    AnalyticJourneyInsights,
    AnalyticInsights,
    AnalyticInsightsSettings,
    AnalyticReports,
    AnalyticReportSettings,
    AnalyticScore,
    AnalyticSVSocial,
    AnalyticTornado,
    AnalyticTrafficInsights,
    AnalyticVOBReviewResponding,
    AnalyticVOBReviewRespondingDashboard,
    AnalyticVOBConfiguration,
    AnalyticVOCIndustry,
    AnalyticVOEPeople,
    AnalyticWordCloud,
    AnalyticCompetitiveInsightsCompassLocationComparison,
    AnalyticCompetitiveInsightsCompassBrandComparison,
    AnalyticCompetitiveInsightsCompassExperienceAnalysis,
    AnalyticCompetitiveInsightsCompassCommentExploration,
    AnalyticCompetitiveInsightsCompassJourneyInsights,
    AnalyticCompetitiveInsightsCompassSWOTReviews,
    AnalyticCompetitiveInsightsCompassSWOTWebSources,
    AssetLibrary,
    CommandCenter,
    CompetitiveInsightsBasic,
    CompetitiveInsightsLocal,
    CompetitiveInsightsNational,
    Datastore,
    DirectoryFinder,
    DirectoryListings,
    DirectoryListingsDuplicate,
    DirectoryListingPosts,
    DirectoryListingMappings,
    DirectoryListingSettings,
    DirectoryLocator,
    DirectoryPages,
    DirectoryProfileFields,
    DirectoryProfiles,
    DirectoryRichContent,
    DirectorySuggestions,
    EngageDashboards,
    EngageEngagements,
    EngageIntegrations,
    EngagePreferences,
    EngageQueues,
    EngageReports,
    EngageSegments,
    EngageStandardResponses,
    EngageTags,
    GSRRatings,
    HashtagGroup,
    Integrations,
    KioskReviews,
    KioskSettings,
    KioskResponses,
    KioskResponseSettings,
    ListenAlerts,
    ListenDashboards,
    ListenDashboardTemplates,
    ListenHistoricalData,
    ListenIntegrations,
    ListenMentions,
    ListenMonitors,
    ListenPreferences,
    ListenReports,
    ListenSegments,
    ListenTags,
    ManagedServicesCredentials,
    MessagingAutomatedResponses,
    MessagingCampaigns,
    MessagingInboxConversations,
    MessagingInboxResponses,
    NewReportingPlatformDashboard,
    NewReportingPlatformReport,
    PlatformAutomatedResponses,
    PlatformAutomationRules,
    PlatformCensorData,
    PlatformCompetitorLocations,
    PlatformCredentials,
    PlatformCustomTabs,
    PlatformCustomers,
    PlatformDashboards,
    PlatformDataProtection,
    PlatformEducation,
    PlatformEmployeeAttribution,
    PlatformHelp,
    PlatformImportJobs,
    PlatformInboxAttachments,
    PlatformInboxConversations,
    PlatformInboxSettings,
    PlatformInternalEmails,
    PlatformLocations,
    PlatformMacros,
    PlatformManagedServices,
    PlatformMyAccount,
    PlatformNotifications,
    PlatformNuviSettings,
    PlatformObjectPrivileges,
    PlatformPII,
    PlatformRoles,
    PlatformSources,
    PlatformSuggestedResponses,
    PlatformSuggestedResponseSettings,
    PlatformTags,
    PlatformTemplates,
    PlatformTenants,
    PlatformTestimonials,
    PlatformUI,
    PlatformUsers,
    PlatformUTMParams,
    PlatformWidgets,
    PlatformPrivilegedAccessManagementTags,
    PlatformPrivilegedAgencies,
    PlatformPrivilegedCompetitorLocations,
    PlatformPrivilegedCredentials,
    PlatformPrivilegedDefaultRoles,
    PlatformPrivilegedDirectoryListings,
    PlatformPrivilegedFeatureFlags,
    PlatformPrivilegedLinkShortener,
    PlatformPrivilegedLocations,
    PlatformPrivilegedManagedServices,
    PlatformPrivilegedModules,
    PlatformPrivilegedReports,
    PlatformPrivilegedRest2Thrift,
    PlatformPrivilegedSKUs,
    PlatformPrivilegedSources,
    PlatformPrivilegedAgencyRoles,
    PlatformPrivilegedAgencyUsers,
    AgencyUserProvisioner,
    PlatformPrivilegedTenants,
    PlatformPrivilegedUsers,
    PlatformSuperPrivilegedAgencies,
    PublishDashboards,
    PublishGallery,
    PublishIntegrations,
    PublishPosts,
    PublishPreferences,
    PublishReports,
    PublishSegments,
    PublishSmartSocial,
    PublishWorkflows,
    QA,
    QAResponses,
    RepConnectAdmin,
    RepIQReviews,
    RepScoreImpactReport,
    Requests,
    RequestLeaderboard,
    RequestMetrics,
    RequestSettings,
    RequestTemplates,
    Reviews,
    ReviewAttributions,
    ReviewInboxConversations,
    ReviewInboxResponses,
    ReviewSettings,
    ReviewResponses,
    ReviewResponseSettings,
    ScoreBasicScore,
    ScorePrescriptiveScore,
    ScoreTargetsScore,
    SearchInsightAnalytics,
    SearchInsightAnalyticSettings,
    SocialCampaigns,
    SocialCampaignMetrics,
    SocialCurationQueues,
    SocialCurationSettings,
    SocialCurationTasks,
    SocialInboxConversations,
    SocialInboxResponses,
    SocialListeningLivestream,
    SocialListeningMetrics,
    SocialMetrics,
    SocialPosts,
    SocialResponses,
    SocialPublishPosts,
    SocialRepoContent,
    SocialRepoFeeds,
    SocialRepoTags,
    SurveyInboxConversations,
    SurveyInboxResponses,
    SurveyLegacyResults,
    SurveyLegacyResponses,
    SurveyResults,
    SurveySettings,
    SurveyResponses,
    SurveyResponseSettings,
    SurveyTemplates,
    SurveySummaries,
    Survey3BasicTemplates,
    Survey3Conversational,
    Survey3Results,
    Survey3ResultsFeedUpdate,
    Survey3Settings,
    Survey3Responses,
    Survey3SharedFolders,
    Survey3ResponseManager,
    Survey3ResponseSettings,
    Survey3Templates,
    Survey3FraudProtection,
    Survey3Summaries,
    Tasks,
    TaskActivities,
    TaskContacts,
    TaskDetails,
    TaskNotes,
    TaskSettings,
    Tickets,
    TicketEscalations,
    TicketClosingReasons,
    TicketCustomDefinitions,
    TicketAttachments,
    TicketNotes,
    TicketPII,
    TicketQueues,
    TicketRootCauses,
    TicketRules,
    TicketStages,
    TicketTags,
    TicketPrivilegedTickets,
    AutoFindResults,
    ApiKeyTenantProvisioner,
    ApiKeyAgencyProvisioner,
    NuviSocial,
};
